// extracted by mini-css-extract-plugin
export default {"bold":"components-RichText-styles-module__bold--dCp0m"};